module.exports = __webpack_public_path__ + "static/media/waterCloset.33afe6f3.svg";